import { HomeService } from './../../home/home.service';
import { Component, ElementRef, OnInit, ViewChild } from "@angular/core";
import { environment } from "../../../environments/environment";
import * as Papa from 'papaparse';

import {
  PoNotificationService,
  PoTableAction,
  PoComboOption,
  PoTableColumn,
  PoModalAction,
  PoModalComponent,
  PoRadioGroupOption,
} from "@po-ui/ng-components";
import { Router } from "@angular/router";
import { OrcamentoFormService } from "./orcamento-form.service";
import { OrcamentoStatus } from "../orcamento-status.enum";
import { Impostos } from "./imposto";
import { FormsModule } from '@angular/forms';
import { firstValueFrom } from 'rxjs';
import { ImportacaoService } from './importacao';

@Component({
  selector: "app-orcamento-form",
  templateUrl: "./orcamento-form.component.html",
  styleUrls: ["./orcamento-form.component.css"],
  standalone: false,
})

export class OrcamentoFormComponent implements OnInit {
  columns: Array<PoTableColumn> = [];
  items: Array<any> = [];

  produtoColumns: Array<PoTableColumn> = [];
  produtoItems: Array<any> = [];

  columnsSimilar: Array<PoTableColumn> = [];
  itemsSimilar: Array<any> = new Array();

  readonly BuscaOptions: Array<PoRadioGroupOption> = [
    { label: "Início do texto", value: "I" },
    { label: "Contém texto", value: "" },
    { label: "Final do texto", value: "F" },
  ];

  status: string;
  valorMinimo: number = 500;
  data: Date = new Date();
  emissao: Date;
  options: Array<any> = new Array();
  optionsCod: Array<any> = new Array();
  produtoSelect: string;
  CodigoProdutoSelect: string;
  produto: string;
  produtoTemp: string;
  existeNaGrade = false;
  clienteSelect: string;
  TpFreteSelect: string;
  optionsProdutos: Array<any> = new Array();
  quantidade: number;
  quantidadeTemp: number = 0;
  name: string;
  email: string;
  ie: string;
  fone: string;
  endereco: string;
  um: string;
  ufCliente: string;
  subTotal = 0;
  ipi = 0;
  icms = 0;
  vlrFrete = 0;
  desconto: number = 0.0;
  total = 0;
  qtdTotal = 0;
  precoUni: number;
  cabOrcamento: Array<any> = new Array();
  informaTransp: boolean;
  id: String;
  transOptions: Array<PoComboOption>;
  transportadorSelect: String;
  condPgOptions: Array<any> = new Array();
  CondpgSelect: String;
  observacao: String;
  transportadorasOp: Array<any> = new Array();
  vendaFutura: String;
  isHideLoading = false;
  impostos;
  urlBuscaCli = `${environment.API}listaclientes`;
  _impostos: any;
  descontoCli: number;
  produtoEspecif: string;

  listaCliente: any;
  segmento: string;
  nome: string;
  codigo: string;
  produtoFiltro: string;
  limite: string;
  tpconsulta: string;

  isPecas: boolean;
  indexAltera: number;

  saldoEstoque: number;

  length: number;

  actions: Array<PoTableAction> = [
    {
      action: this.alterar.bind(this),
      icon: "po-icon po-icon-edit",
      label: "Alterar",
    },
    {
      action: this.remover.bind(this),
      icon: "po-icon po-icon-delete",
      label: "Excluir",
    },
  ];

  actionsProdutos: Array<PoTableAction> = [
    {
      action: this.addProduto.bind(this),
      icon: "po-icon po-icon-plus-circle",
      label: "Adicionar",
    },
  ];
  pohelp: string;
  tabprc: string;
  copyItems: any[];


  constructor(
    private orcamentoFormService: OrcamentoFormService,
    private poNotification: PoNotificationService,
    private router: Router,
    private homeService: HomeService,
    public importacaoService: ImportacaoService
  ) { }

  @ViewChild(PoModalComponent, { static: true }) poModal: PoModalComponent;
  @ViewChild("AddProduto", { static: true }) AddProduto: PoModalComponent;
  @ViewChild("AlteraProduto", { static: true }) AlteraProduto: PoModalComponent;
  @ViewChild('csvInput') csvInput: ElementRef<HTMLInputElement>;

  // Se desejar exibir dados lidos:
  csvData: any[] = [];

  async ngOnInit() {
    this.pohelp = ' ';
    this.isPecas = sessionStorage.getItem("Segmento") === "PECAS";
    this.columns = this.orcamentoFormService.getColumns();
    this.items = this.orcamentoFormService.getItems();
    this.desconto = 0
    this.length = 15;

    try {
      this.condPgOptions = await this.getOptCondPagamentos();
    } catch (error) {
      console.error("Erro ao obter condições de pagamento:", error);
    }

    this.segmento = sessionStorage.getItem("Segmento");
    this.status = "Inclusão";
    this.emissao = this.data;
    this.informaTransp = true;
    this.isHideLoading = true;
    this.vendaFutura = "N";
    this.produtoColumns = this.orcamentoFormService.getProdutosColumns();
    //this.produtoItems = this.getOptProdutos(this.segmento, "");
    this.columnsSimilar = this.orcamentoFormService.getSimilarColumns();
    this.tpconsulta = "I";

    this.orcamentoFormService.getLimiteNoCartao().subscribe({
      next: (data) => {
        // sessionStorage.setItem("limiteNoCartao",data.descricao);
        this.limite = data.descricao
      }
    })

    this.orcamentoFormService.getValorMinimo().subscribe({
      next: (data) => {
        if (data) {
          const val = parseFloat(data.descricao || data.CONTEUDO || data.valor || data);
          if (!isNaN(val) && val > 0) {
            this.valorMinimo = val;
            sessionStorage.setItem("valorMinimoOrcamento", val.toString());
          }
        }
      },
      error: () => {
        const cached = sessionStorage.getItem("valorMinimoOrcamento");
        if (cached) {
          this.valorMinimo = parseFloat(cached) || 500;
        }
      }
    })

    this.ufCliente = sessionStorage.getItem('ufcli')
  }

  updateTotais() {
    //  var valorFrete = this.vlrFrete > 0 ? this.vlrFrete : 0;
    this.total = 0;
    this.subTotal = 0;
    this.ipi = 0;
    this.icms = 0;
    this.qtdTotal = 0;
    //console.log(this.items);
    for (let i = 0; i < this.items.length; i++) {
      this.subTotal += this.items[i].vlruni * this.items[i].quantity;
      this.total += this.items[i].total;
      this.ipi += this.items[i].ipi * this.items[i].quantity;
      this.icms += this.items[i].icms * this.items[i].quantity;
      this.qtdTotal += this.items[i].quantity;
    }
  }

  closeModal() {
    this.AddProduto.close();
  }

  closeModalProdutos() {
    this.poModal.close();
  }

  closeModalAlterar: PoModalAction = {
    action: () => {
      this.closeModal();
    },
    label: "Voltar",
    danger: true,
  };

  confirm: PoModalAction = {
    action: () => {
      this.closeModalProdutos();
    },
    label: "Voltar",
  };

  AddProdutoBotao: PoModalAction = {
    action: () => {
      this.isHideLoading = false;
      if (sessionStorage.getItem("cpcred").indexOf(this.CondpgSelect.toString()) != -1) {
        this.tabprc = sessionStorage.getItem("tabesp");
      } else {
        this.tabprc = sessionStorage.getItem("tabprc");
      }
      if (this.quantidade > 0) {
        let existe = false;
        for (let i = 0; i < this.items.length; i++) {
          if (this.items[i].code === this.CodigoProdutoSelect) {
            existe = true;
          }
        }
        if (!existe) {
          this.AddProduto.close();
          this.closeModalProdutos();
          this.orcamentoFormService
            .getPreco(
              this.tabprc,
              this.CodigoProdutoSelect,
              this.segmento
            )
            .subscribe(async (preco) => {
              if (preco.length > 0) {
                await this.retImpostos(
                  this.CodigoProdutoSelect,
                  preco[0].precoTabela,
                  this.quantidade
                );

                if (this._impostos === undefined || this._impostos.length === 0) {
                  throw new Error("Não foi possível carregar os impostos, solicite revisão no cadastro desse produto.");
                }

                if (this._impostos[0].PRODUTO == "NON") {
                  this.poNotification.error("Não foi possível carregar os impostos, por favor, logue outra vez e tente novamente.");
                } else {
                  this.items.push(
                    this.orcamentoFormService.generateNewItem(
                      this.items.length + 1,
                      this.quantidade,
                      this.produto,
                      this.CodigoProdutoSelect,
                      Math.round(preco[0].precoTabela * 100),
                      Math.round(this._impostos[0].TOTAL * 100),
                      this.um,
                      Math.round(this.desconto * 100),
                      Math.round(this._impostos[0].IPI * 100),
                      Math.round(this._impostos[0].ICMS * 100),
                      // this._impostos[0].TOTAL * this.quantidade
                    )
                  );
                  this.updateTotais();
                }
                this.AddProduto.close();
              } else {
                this.poNotification.error(
                  "Produto indisponível, consultar área comercial"
                );
                this.AddProduto.close();
                this.closeModal();
              }
              //    this.closeModal();
              //   this.poNotification.success("Produto adicionado com sucesso!");
            });
        } else {
          this.poNotification.error("Produto adicionado anteriormente!");
          this.AddProduto.close();
          this.closeModal();
        }
      } else {
        this.AddProduto.close();
      }
      this.isHideLoading = true;
    },
    label: "Confirmar",
  };

  addQtdProdutos() {
    this.quantidade += 1;
  }
  rmQtdProdutos() {
    if (this.quantidade > 0) {
      this.quantidade -= 1;
    }
  }

  attHelp() {
    this.copyItems = [];
    if (sessionStorage.getItem("cpcred").indexOf(this.CondpgSelect.toString()) != -1) {
      this.tabprc = sessionStorage.getItem("tabesp");
      this.pohelp = '* Com Acréscimo'
    } else {
      this.pohelp = ' '
      this.tabprc = sessionStorage.getItem("tabprc");
    }
    if (this.items.length > 0) {
      this.copyItems = this.items;
      this.items = [];
      for (let i = 0; i < this.copyItems.length; i++) {
        this.orcamentoFormService
          .getPreco(
            this.tabprc,
            this.copyItems[i].code,
            this.segmento
          )
          .subscribe(async (preco) => {
            if (preco.length > 0) {
              await this.retImpostos(
                this.copyItems[i].code,
                preco[0].precoTabela,
                this.copyItems[i].quantity
              );

              if (this._impostos === undefined || this._impostos.length === 0) {
                throw new Error("Não foi possível carregar os impostos, solicite revisão no cadastro desse produto.");
              }

              if (this._impostos[0].PRODUTO == "NON") {
                this.poNotification.error("Não foi possível carregar os impostos, por favor, logue outra vez e tente novamente.");
              } else {
                this.items.push(
                  this.orcamentoFormService.generateNewItem(
                    this.copyItems.length + 1,
                    this.copyItems[i].quantity,
                    this.copyItems[i].product,
                    this.copyItems[i].code,
                    Math.round(preco[0].precoTabela * 100),
                    Math.round(this._impostos[0].TOTAL * 100),
                    this.copyItems[i].unidadem,
                    0,
                    Math.round(this._impostos[0].IPI * 100),
                    Math.round(this._impostos[0].ICMS * 100),
                    // this._impostos[0].TOTAL * this.copyItems[i].quantity
                  )
                );
                this.updateTotais();
              }
            } else {
              this.poNotification.error(
                "Produto indisponível, consultar área comercial"
              );
            }
            //    this.closeModal();
            //   this.poNotification.success("Produto adicionado com sucesso!");
          });
      }
    }
  }

  async addProduto(item: { codigo: string; produto: string; especif: string; un: string; }) {
    let naoPermitidoCredito = null
    let limite = Number(this.limite)

    if (sessionStorage.getItem("cpcred").indexOf(this.CondpgSelect.toString()) != -1) {
      this.tabprc = sessionStorage.getItem("tabesp");

      this.orcamentoFormService.getPreco(this.tabprc, item.codigo, this.segmento).subscribe({
        next: (pagto) => {
          if (pagto[0].precoTabela >= limite) {
            naoPermitidoCredito = true
          } else {
            naoPermitidoCredito = false
          }
        },
        complete: async () => {
          naoPermitidoCredito

          if (naoPermitidoCredito) {
            this.poNotification.warning("Produtos com valores a partir de " + limite.toLocaleString() + " não podem ser pagos com cartão de crédito!")
          } else {
            let similar: Array<any>;
            this.isHideLoading = false;
            this.quantidade = null;
            this.itemsSimilar = [];
            this.produtoSelect = item.codigo + " " + item.produto;
            this.produtoEspecif = item.especif;
            this.CodigoProdutoSelect = item.codigo;
            this.produto = item.produto;
            this.um = item.un;
            await this.consultaSaldo(item.codigo);
            //console.log(this.isPecas);
            if (this.isPecas) {
              this.orcamentoFormService
                .getSimilar(this.CodigoProdutoSelect)
                .subscribe((Similar) => {
                  similar = Similar;
                  for (let i = 0; i < similar.length; i++) {
                    // console.log(similar[i].similar);
                    this.itemsSimilar.push(
                      this.orcamentoFormService.generateNewItemSimilar(
                        similar[i].similar,
                        similar[i].descricao
                      )
                    );
                  }

                  this.AddProduto.open();
                });
            } else {
              this.AddProduto.open();
            }
            this.isHideLoading = true;
          }
        }
      })

    } else {
      this.tabprc = sessionStorage.getItem("tabprc");

      let similar: Array<any>;
      this.isHideLoading = false;
      this.quantidade = null;
      this.itemsSimilar = [];
      this.produtoSelect = item.codigo + " " + item.produto;
      this.produtoEspecif = item.especif;
      this.CodigoProdutoSelect = item.codigo;
      this.produto = item.produto;
      this.um = item.un;
      await this.consultaSaldo(item.codigo);
      //console.log(this.isPecas);
      if (this.isPecas) {
        this.orcamentoFormService
          .getSimilar(this.CodigoProdutoSelect)
          .subscribe((Similar) => {
            similar = Similar;
            for (let i = 0; i < similar.length; i++) {
              // console.log(similar[i].similar);
              this.itemsSimilar.push(
                this.orcamentoFormService.generateNewItemSimilar(
                  similar[i].similar,
                  similar[i].descricao
                )
              );
            }

            this.AddProduto.open();
          });
      } else {
        this.AddProduto.open();
      }
      this.isHideLoading = true;
    }
  }

  AlteraProdutoBotao: PoModalAction = {
    action: () => {
      if (this.quantidade > 0) {
        let index = this.indexAltera;
        this.items[index].quantity = this.quantidade;
        this.items[index].total = this.quantidade * this.items[index].vlruni_imp;
        this.updateTotais();
        this.AlteraProduto.close();
        this.poNotification.setDefaultDuration(1500);
        this.poNotification.success("Produto alterado");
      } else {
        this.AlteraProduto.close();
      }
    },
    label: "Confirmar",
  };

  async BuscaProduto() {
    this.produtoItems = [];
    if (this.produtoFiltro) {
      this.produtoItems = await this.getOptProdutos(
        this.segmento,
        this.produtoFiltro,
        this.tpconsulta,
        sessionStorage.getItem("tabprc")
      );
    }
  }

  async getOptProdutos(segmento, filtro, tpconsulta, tabprc): Promise<any[]> {
    this.optionsProdutos = [];
    this.isHideLoading = false;

    try {
      const Produtos = await firstValueFrom(
        this.orcamentoFormService.getProdutos(segmento, filtro, tpconsulta, tabprc, this.ufCliente)
      );

      this.optionsProdutos = Produtos.map((produto) => ({
        codigo: produto.codigo,
        produto: produto.descricao,
        especif: produto.especifico,
        un: produto.un,
      }));

      this.isHideLoading = true;
      return this.optionsProdutos;
    } catch (error) {
      console.error("Erro ao buscar produtos:", error);
      this.isHideLoading = true;
      return [];
    }
  }


  async getOptCondPagamentos(): Promise<PoComboOption[]> {
    this.condPgOptions = [];

    try {
      const filter = sessionStorage.getItem("cpg")?.split("|") || [];
      const condicoes = await firstValueFrom(this.orcamentoFormService.getcondPagamentos(filter));

      this.condPgOptions = condicoes.map(condicao => ({
        label: condicao.nome,
        value: condicao.codigo,
      }));

      return this.condPgOptions;
    } catch (error) {
      console.error("Erro ao carregar condições de pagamento:", error);
      return [];
    }
  }

  async addItem() {
    if (this.CondpgSelect) {
      this.poModal.open();
    } else {
      this.poNotification.error("Por favor, informe a condição de pagamento antes.");
    }
  }

  async addItemFromHome() {
    if (this.CondpgSelect) {
      this.produtoItems = [];
      this.produtoFiltro = null;
      if (this.produtoTemp && this.quantidadeTemp > 0) {
        console.log('Condpg', this.CondpgSelect, 'Produto', this.produtoTemp, 'Qtd', this.quantidadeTemp);
        await this.inclusaoDireta(true, []);
        this.produtoTemp = '';
        this.quantidadeTemp = 0;
        this.isHideLoading = true;
      } else {
        this.poNotification.error("Os campos de Cód. Produto e Quantidade devem ser preenchidos.");
      }
    } else {
      this.poNotification.error("Por favor, informe a condição de pagamento antes.");
    }
  }

  // Acionada ao clicar no botão
  onUploadCsv() {
    this.csvInput.nativeElement.value = ''; // Limpa seleção anterior
    this.csvInput.nativeElement.click();
  }

  onBaixarModelo() {
    // Cabeçalho e observação
    const cabecalho = [['Produto', 'Quantidade']];
    const observacao = 'Aviso: Não apagar o conteudo das linhas 01 e 02. Preencher a partir da linha 03';
    const nomeArquivo = `modelo_importacao.csv`;

    // Geração do conteúdo CSV
    const csv = Papa.unparse(cabecalho, { delimiter: ";" });

    // Conteúdo final com BOM e observação
    const conteudoFinal = '\uFEFF' + observacao + '\n' + csv;

    // Criação do Blob e link de download
    const blob = new Blob([conteudoFinal], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', nomeArquivo);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  async onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (!input.files || !input.files.length) return;

    this.importacaoService.impOn()

    const file = input.files[0];
    const reader = new FileReader();

    reader.onload = async () => {
      const tamCabecalho = 2;
      let csv = reader.result as string;

      // === ADAPTAÇÃO PARA IGNORAR AS 2 PRIMEIRAS LINHAS ===
      // Se quiser ignorar N linhas, troque o 2 por N
      const linhas = csv.split('\n').slice(tamCabecalho - 1); // Ignora as DUAS primeiras linhas
      csv = linhas.join('\n');
      // === FIM DA ADAPTAÇÃO ===

      Papa.parse(csv, {
        header: true,
        skipEmptyLines: true,
        complete: async (result) => {
          try {
            await this.processarDadosEmLotes(result.data);
            this.produtoTemp = ''
            this.quantidadeTemp = 0
            this.poNotification.success("Importação realizada com sucesso!");
          } catch (error) {
            this.poNotification.error(`Erro ao importar produtos: ${error.message}`);
          } finally {
            this.importacaoService.impOff()
          }
        },
        error: (error) => {
          this.poNotification.error(`Erro ao processar CSV: ${error.message}`);
        }
      });
    };

    reader.readAsText(file, 'UTF-8');
  }

  async processarDadosEmLotes(data: any[]) {
    const tamanhoLote = 10;
    const numeroLotes = Math.ceil(data.length / tamanhoLote);
    const errosImportacao: { linha: number, Produto: string, Quantidade: number, mensagem: string }[] = [];

    this.importacaoService.progressBarLen = data.length;

    for (let i = 0; i < numeroLotes; i++) {
      const lote = data.slice(i * tamanhoLote, (i + 1) * tamanhoLote);
      for (const [index, el] of lote.entries()) {
        try {
          this.produtoTemp = el.Produto;
          this.quantidadeTemp = Number(el.Quantidade);
          await this.inclusaoDireta(false, errosImportacao); // Passar número da linha e código do produto, se desejar
          this.importacaoService.increment()
        } catch (error) {
          for (const [index, el] of lote.entries()) {
            try {
              this.produtoTemp = el.Produto;
              this.quantidadeTemp = Number(el.Quantidade);
              await this.inclusaoDireta(false, errosImportacao);
              this.importacaoService.increment()
            } catch (error) {
              errosImportacao.push({
                linha: i * tamanhoLote + index + 1, // Linha do arquivo, começando em 1
                Produto: el.Produto,
                Quantidade: Number(el.Quantidade),
                mensagem: error.message || 'Erro desconhecido'
              });
            }
          }
        }
      }
    }

    this.importacaoService.impOff()

    if (errosImportacao.length) {
      this.poNotification.setDefaultDuration(15000);
      this.poNotification.warning(`Foram encontrados ${errosImportacao.length} erros na importação. Baixando arquivo...`);
      this.poNotification.setDefaultDuration(6000);
      this.exportarErrosParaCsv(errosImportacao);
    } else {
      this.poNotification.success('Produtos importados com sucesso!');
    }
  }

  private exportarErrosParaCsv(erros: any[]) {
    // Gera data/hora atual no formato desejado
    const agora = new Date();
    const pad = (n: number) => n.toString().padStart(2, '0');
    const dataHora =
      agora.getFullYear() + '-' +
      pad(agora.getMonth() + 1) + '-' +
      pad(agora.getDate()) + '_' +
      pad(agora.getHours()) + '-' +
      pad(agora.getMinutes()) + '-' +
      pad(agora.getSeconds());

    const nomeArquivo = `erros_importacao_${dataHora}.csv`;
    // Mensagem de observação a ser adicionada na primeira linha
    const observacao = 'Essa planilha de erros pode ser usada para importar os itens após correções adequadas';

    // Gera o conteúdo CSV dos erros normalmente
    const csv = Papa.unparse(erros, { header: true, delimiter: ";" });

    // Adiciona BOM para garantir reconhecimento do UTF-8 no Excel
    // Atenção: O BOM deve estar ANTES DE TUDO no arquivo!
    const conteudoFinal = '\uFEFF' + observacao + '\n' + csv;

    const blob = new Blob([conteudoFinal], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', nomeArquivo);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  async remover(item) {
    //this.subTotal -= this.items[this.items.indexOf(item)].total;
    this.isHideLoading = false;
    this.items.splice(this.items.indexOf(item), 1);
    //await this.recalculaImpostos();
    this.updateTotais();
    this.isHideLoading = true;
    this.poNotification.setDefaultDuration(1500);
    this.poNotification.error("Produto removido");
  }

  async alterar(item) {
    let similar: Array<any>;
    this.quantidade = null;
    this.itemsSimilar = [];
    let index = this.items.indexOf(item);
    this.indexAltera = index;
    this.produtoSelect =
      this.items[index].code + " " + this.items[index].product;
    this.produtoEspecif = this.items[index].especif;
    this.quantidade = this.items[index].quantity;
    this.um = this.items[index].unidadem;
    if (this.isPecas) {
      this.orcamentoFormService
        .getSimilar(this.items[index].code)
        .subscribe((Similar) => {
          similar = Similar;
          for (let i = 0; i < similar.length; i++) {
            this.itemsSimilar.push(
              this.orcamentoFormService.generateNewItemSimilar(
                similar[i].similar,
                similar[i].descricao
              )
            );
          }
          this.AlteraProduto.open();
        });
    } else {
      this.AlteraProduto.open();
    }
  }

  //id`,`numPedido`,`cgc`,`emissao`,`condPagamento`,`notaFiscal`,`status`,`valorTotal`,`vendedor`,`observacao`
  salvaOrcamento() {
    if (this.total > 0) {
      if (this.items.length > 0) {
        this.cabOrcamento.pop();
        const statusOrcamento = (this.total < this.valorMinimo && this.segmento === 'PECAS') ? OrcamentoStatus.LIMITE_NAO_ATINGINDO : OrcamentoStatus.EM_ELABORACAO;
        this.cabOrcamento.push({
          cgc: sessionStorage.getItem("cgc"),
          emissao: this.emissao,
          status: statusOrcamento,
          valorTotal: this.total,
          condPagamento: this.CondpgSelect,
          vendedor: sessionStorage.getItem("userVendedor"),
          observacao: this.observacao,
          segmto: this.segmento,
          frete: 0,
          user: sessionStorage.getItem("codeuser"),
          tabela: this.tabprc
        });
        this.orcamentoFormService
          .SalvaCabOrcamento(this.cabOrcamento)
          .subscribe(async (CabOrcamento) => {
            var itens: Array<any> = new Array();

            for (let index = 0; index < this.items.length; index++) {
              //this.items[index];
              itens.push({
                idCab: CabOrcamento.id,
                item: index.toString(),
                codProduto: this.items[index].code,
                DescProduto: this.items[index].product,
                un: this.items[index].unidadem,
                quantidade: this.items[index].quantity,
                qtdLiberada: 0,
                precoTabela: this.items[index].vlruni,
                prcUnitario: this.items[index].vlruni,
                precoImposto:
                  this.items[index].total / this.items[index].quantity,
                valorTotal: this.items[index].total,
                valorDesconto: 0,
              });
            }
            await this.orcamentoFormService
              .SalvaItensOrcamento(itens)
              .subscribe((ItensOrcamento) => { });
            this.poNotification.success(CabOrcamento.status);
            this.router.navigate([`orcamento`], {});
          });
      } else {
        this.poNotification.setDefaultDuration(1500);
        this.poNotification.error("Orçamento sem itens");
      }
    } else {
      this.poNotification.setDefaultDuration(1500);
      this.poNotification.error("Favor, recalcular orçamento!");
    }
  }

  async retImpostos(Produto, ValorUni, Qtd) {
    var Dados: Array<any> = new Array();

    if (this.importacaoService.importandoItens) {
      this.isHideLoading = true;
    } else {
      this.isHideLoading = false;
    }

    var impostoItem: Impostos = new Impostos();
    impostoItem.Qtd = Qtd;
    impostoItem.ValorUni = ValorUni;
    impostoItem.Desconto = 0;
    impostoItem.Frete = 0;
    impostoItem.Produto = Produto;
    impostoItem.tpop = sessionStorage.getItem("tpop");
    impostoItem.Despesa = 0;
    Dados.push(impostoItem);
    let empresa = sessionStorage.getItem("empresa");


    await this.orcamentoFormService
      .getImpostos(sessionStorage.getItem("cgc"), Dados, empresa)
      .then((response) => (this._impostos = response));
    this.isHideLoading = true;
  }

  async consultaSaldo(produto) {
    var Qtd = 0;
    this.saldoEstoque = null;
    await this.orcamentoFormService
      .getEstoqueP(produto)
      .then((response) => (Qtd = response.QUANTIDADE));
    if (Qtd > 0) {
      this.saldoEstoque = Qtd;
    }
  }

  async inclusaoDireta(mostraerro: boolean, errosImportacao: any[]) {
    if (this.importacaoService.importandoItens) {
      this.isHideLoading = true;
    } else {
      this.isHideLoading = false;
    }

    const quantidadeTemp = parseInt(this.quantidadeTemp.toString())
    const produtoTemp = this.produtoTemp;
    const condpgSelect = this.CondpgSelect;
    const segmento = this.segmento;

    this.CodigoProdutoSelect = produtoTemp;

    try {
      // Buscar informações do produto primeiro
      const produto = await firstValueFrom(
        this.orcamentoFormService.getProdutoByCodigo(produtoTemp)
      );

      if (produto.bloqueado !== 'N') {
        throw new Error("Produto bloqueado para venda!");
      }

      if (produto) {
        this.produto = produto.descricao;
        this.um = produto.un;
      } else {
        throw new Error("Produto não encontrado"); // Força cair no catch
      }

      // Continuar com o fluxo original após ter os dados do produto
      if (sessionStorage.getItem("cpcred").indexOf(condpgSelect.toString()) != -1) {
        this.tabprc = sessionStorage.getItem("tabesp");
      } else {
        this.tabprc = sessionStorage.getItem("tabprc");
      }

      if (quantidadeTemp <= 0 || isNaN(quantidadeTemp)) {
        throw new Error("Quantidade inválida: informe um valor maior que zero.");
      }

      let existe = false;

      for (let i = 0; i < this.items.length; i++) {
        if (this.items[i].code === this.CodigoProdutoSelect) {
          existe = true;
        }
      }

      if (!existe) {
        this.AddProduto.close();
        this.closeModalProdutos();

        try {
          // Obter preço
          const preco = await firstValueFrom(
            this.orcamentoFormService.getPreco(
              this.tabprc,
              this.CodigoProdutoSelect,
              segmento
            )
          );

          if (preco && preco.length > 0) {
            // Obter impostos
            await this.retImpostos(
              this.CodigoProdutoSelect,
              preco[0].precoTabela,
              quantidadeTemp
            );

            if (this._impostos === undefined || this._impostos.length === 0) {
              throw new Error("Não foi possível carregar os impostos, solicite revisão no cadastro desse produto.");
            }

            if (this._impostos[0].PRODUTO == "NON") {
              // Se quiser, pode lançar erro personalizado aqui também
              throw new Error("Não foi possível carregar os impostos, por favor, logue outra vez e tente novamente.");
            } else {
              // Adicionar o item à lista

              if (this.desconto === undefined || this.desconto === null) {
                this.desconto = 0;
              }

              this.items.push(
                this.orcamentoFormService.generateNewItem(
                  this.items.length + 1,
                  quantidadeTemp,
                  this.produto,
                  this.CodigoProdutoSelect,
                  Math.round(preco[0].precoTabela * 100),
                  Math.round(this._impostos[0].TOTAL * 100),
                  this.um,
                  Math.round(this.desconto * 100),
                  Math.round(this._impostos[0].IPI * 100),
                  Math.round(this._impostos[0].ICMS * 100),
                  // this._impostos[0].TOTAL * quantidadeTemp
                )
              );
              this.updateTotais();
            }
            this.AddProduto.close();
          } else {
            // Produto não retornou preço, pode lançar erro específico
            this.AddProduto.close();
            this.closeModal();
            throw new Error("Produto indisponível, consultar área comercial");
          }
        } catch (error) {
          this.AddProduto.close();
          this.closeModal();
          // Aqui você apenas relança o erro para ser tratado pelo try/catch mais externo
          throw error;
        }
      } else {
        this.AddProduto.close();
        this.closeModal();
        throw new Error("Produto adicionado anteriormente!");
      }

      this.AddProduto.close();
    } catch (error) {
      let mensagemErro = "Erro inesperado";

      // Tratamento robusto do erro
      if (error instanceof Error && error.message) {
        mensagemErro = error.message;
      } else if (error && typeof error === 'object') {
        if ('error' in error && error.error) {
          if (typeof error.error === 'string') {
            mensagemErro = error.error;
          } else if (typeof error.error === 'object' && error.error.message) {
            mensagemErro = error.error.message;
          }
        } else if ('message' in error && error.message) {
          mensagemErro = error.message;
        }
      } else if (typeof error === 'string') {
        mensagemErro = error;
      }
      if (
        mensagemErro === 'Erro inesperado' &&
        error &&
        error.status === 404
      ) {
        mensagemErro = "Produto não encontrado";
      }

      if (mostraerro) {
        this.poNotification.error(mensagemErro);
        this.AddProduto.close();
      } else {
        console.error('Erro ao buscar produto:', error);
      }

      errosImportacao.push({
        Produto: produtoTemp,
        Quantidade: quantidadeTemp,
        mensagem: mensagemErro
      });
    } finally {
      this.isHideLoading = true; // Sempre ao final, com sucesso ou erro!
    }
  }
}
